export default __webpack_public_path__ + "static/media/qs-icon.807b87ab.webp";